import React from 'react';
import { Button } from './button'; // Assuming button is in the same directory
import { cn } from '@/lib/utils'; // Assuming alias works

// Placeholder for an illustration component (e.g., SVG)
// Use a more specific type for SVG components
type IllustrationComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

interface EmptyStateProps {
  illustration?: IllustrationComponent;
  title: string;
  message: string;
  ctaText?: string;
  onCtaClick?: () => void;
  className?: string;
}

/**
 * A component to display when there is no data to show,
 * optionally including an illustration and a call-to-action button.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  illustration: Illustration,
  title,
  message,
  ctaText,
  onCtaClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center p-8 border border-dashed border-border rounded-lg bg-muted/40 h-full',
        className
      )}
    >
      {Illustration && (
        <Illustration className="h-24 w-24 text-muted-foreground mb-4" />
      )}
      <h3 className="text-lg font-semibold text-foreground mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4">{message}</p>
      {ctaText && onCtaClick && (
        <Button onClick={onCtaClick} size="sm">
          {ctaText}
        </Button>
      )}
    </div>
  );
};

// Example Usage (replace Illustration placeholder)
/*
const ExampleEmptyState = () => (
  <EmptyState 
    // illustration={NoDataIllustration} 
    title="No Appointments Yet"
    message="You don't have any upcoming appointments scheduled."
    ctaText="Schedule an Appointment"
    onCtaClick={() => console.log('CTA Clicked!')}
  />
);
*/ 